(() => {
  const mobile = window.matchMedia('(max-width: 999px)');
  const descriptions = new Map();
  const arrange = () => {
    document.querySelectorAll('.product-block-list__item--description').forEach(description => {
      if (descriptions.has(description)) return;
      const wrapper = description.closest('.product-block-list__wrapper');
      const contact = wrapper?.querySelector('.product-info__block-item--contact');
      if (!contact) return;
      const marker = document.createComment('contact-description-position');
      description.before(marker);
      const toggle = description.querySelector('.expandable-content__toggle-text');
      descriptions.set(description, {
        marker, contact, info: wrapper.querySelector('.product-block-list__item--info'), toggle,
        more: toggle?.dataset.viewMore,
        less: toggle?.dataset.viewLess
      });
    });
    descriptions.forEach((state, description) => {
      if (!state.marker.isConnected || !state.contact.isConnected) {
        descriptions.delete(description);
        return;
      }
      if (mobile.matches) {
        state.info.before(description);
        description.classList.add('contact-mobile-description');
      } else {
        state.marker.after(description);
        description.classList.remove('contact-mobile-description');
      }
      if (state.toggle) {
        state.toggle.dataset.viewMore = mobile.matches ? 'Read more' : state.more;
        state.toggle.dataset.viewLess = mobile.matches ? 'Read less' : state.less;
        const expanded = description.querySelector('.expandable-content')?.getAttribute('aria-expanded') === 'true';
        state.toggle.textContent = expanded ? state.toggle.dataset.viewLess : state.toggle.dataset.viewMore;
      }
    });
  };
  arrange();
  mobile.addEventListener('change', arrange);
  document.addEventListener('shopify:section:load', arrange);
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) return;
    if (!['#eq-project', '#quote', '#hitch-quote', '#photo-quote'].includes(url.hash)) return;
    const target = document.getElementById(url.hash.slice(1));
    const inquiry = target?.closest('[data-custom-inquiry], .em-mobile-custom-contact .eq');
    if (!inquiry) return;
    event.preventDefault();
    event.stopPropagation();
    inquiry.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    if (window.location.hash !== url.hash) window.history.pushState(null, '', url.hash);
  }, true);
})();

